import React from 'react';
import theme from 'styles/theme';

interface SVGAttributeProps extends React.SVGAttributes<HTMLOrSVGElement> {
  width?: number;
  height?: number;
  color?: string;
  filled?: boolean;
}

const LikeIcon = ({
  width = 16,
  height = 16,
  filled = false,
  color = theme.secondary,
  ...rest
}: SVGAttributeProps) => {
  const path = filled
    ? 'M8.11198 15.0611L7.14531 14.1811C3.71198 11.0678 1.44531 9.00776 1.44531 6.49443C1.44531 4.43443 3.05865 2.82776 5.11198 2.82776C6.27198 2.82776 7.38531 3.36776 8.11198 4.21443C8.83865 3.36776 9.95198 2.82776 11.112 2.82776C13.1653 2.82776 14.7786 4.43443 14.7786 6.49443C14.7786 9.00776 12.512 11.0678 9.07865 14.1811L8.11198 15.0611Z'
    : 'M8.06536 12.8667L7.9987 12.9333L7.92536 12.8667C4.7587 9.99333 2.66536 8.09333 2.66536 6.16667C2.66536 4.83333 3.66536 3.83333 4.9987 3.83333C6.02536 3.83333 7.02536 4.5 7.3787 5.40667H8.6187C8.97203 4.5 9.97203 3.83333 10.9987 3.83333C12.332 3.83333 13.332 4.83333 13.332 6.16667C13.332 8.09333 11.2387 9.99333 8.06536 12.8667ZM10.9987 2.5C9.8387 2.5 8.72536 3.04 7.9987 3.88667C7.27203 3.04 6.1587 2.5 4.9987 2.5C2.94536 2.5 1.33203 4.10667 1.33203 6.16667C1.33203 8.68 3.5987 10.74 7.03203 13.8533L7.9987 14.7333L8.96536 13.8533C12.3987 10.74 14.6654 8.68 14.6654 6.16667C14.6654 4.10667 13.052 2.5 10.9987 2.5Z';
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d={path} fill={color} />
    </svg>
  );
};

export default LikeIcon;
